export const ByTimeOfDayHeaders = [
  { label: 'Day of week', key: 'dayOfWeek' },
  { label: 'Time', key: 'time' },
  { label: 'Amount', key: 'amount' },
]
